import {
  HelperBoxContainer,
  IconWrapper,
  TextContainer,
  HelpText,
  HelpTextSmall,
  ContactLink
} from './HelpBox.styles';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import {
  getHelpBoxDefaultContainerStyles,
  getHelpBoxDefaultIconStyles,
  getHelpBoxDefaultContentStyles,
  getHelpBoxDefaultTitleStyles,
  getHelpBoxDefaultLinkStyles,
  getHelpBoxDefaultLinkHoverStyles
} from '../../../../utils/getHelpBoxConfig';

interface HelpBoxProps {
  customTitle?: string;
  customDescription?: string;
  customLinkText?: string;
  customIcon?: string;
  onLinkClick?: () => void;
}

export const HelpBox = ({
  customTitle,
  customDescription,
  customLinkText,
  onLinkClick
}: HelpBoxProps) => {
  const theme = ApiLocalStorage.get('theme') || {};
  const isFml = theme?.login?.helpBoxStyle === 'fml';

  const title = customTitle || theme.contact?.title;
  const description = customDescription || theme.contact?.description;
  const urlContact = theme.contact?.urlContact;

  return (
    <HelperBoxContainer className="vert-fml-helpbox-default-container">
      <IconWrapper className="vert-fml-helpbox-default-icon">
        <ExclamationCircleOutlined color="#FFC107" className="vert-fml-helpbox-default-icon" />
      </IconWrapper>
      <TextContainer className="vert-fml-helpbox-default-content">
        <HelpText className="vert-fml-helpbox-default-title">{title}</HelpText>
        <div>
          <HelpTextSmall dangerouslySetInnerHTML={{ __html: description }} />
          {isFml && urlContact !== '' && urlContact ? (
            <ContactLink
              className="vert-fml-helpbox-default-link"
              href={urlContact}
              target="_blank"
              rel="noopener noreferrer"
            >
              {urlContact}
            </ContactLink>
          ) : (!isFml && urlContact !== '' && urlContact ? (
            <ContactLink href={urlContact} target='_blank'>clique aqui</ContactLink>
          ) : null)}
        </div>
      </TextContainer>
    </HelperBoxContainer>
  );
};
